import React, { useEffect, useState, useRef } from "react";
// Chakra imports
import {
    Box,
    Flex,
    FormControl,
    FormLabel,
    Progress,
    Switch,
    IconButton,
    ButtonGroup,
    Button,
    Text,
    Input
} from "@chakra-ui/react";
import { AddIcon, MinusIcon } from '@chakra-ui/icons'

// react icons
import useGetServices from "hooks/useGetServices";

function EstimateService({
    orderServices,
    setOrderServices,
    // fixedServices = [],
}) {

    // console.log(fixedServices);
    const [ timer, setTimer ] = useState(null);
    const [ keyword, setKeyword ] = useState("");
    const [ showArchived, setShowArchived] = useState(false);

    let { 
        services, 
        setGettingServices, 
        gettingServices, 
        gettingServicesReqSuccess 
    } = useGetServices({ 
        page: 1, 
        limit: 10, 
        keyword: keyword, 
        showArchived: showArchived,
        excludeCover: true,
    });
    
    const [ shownItems, setShownItems ] = useState([]);
    // const [ disabledServices, setDisabledServices ] = useState([]);

    useEffect(() => {
        setGettingServices(true);
    }, []);

    // useEffect(() => {
    //     fixedServices.forEach((fs)=> {
    //         disabledServices.push((fs.serviceId));
    //     });
    // }, [fixedServices]);

    const onOrderServices = (serviceId) => {
        const orderServicesIds = orderServices.map(s => s.id);
        return orderServicesIds.includes(serviceId);
    }


    const onToggleService = (service, checked) => {
        const orderServicesIds = orderServices.map(s => s.id);
        
        if (checked && !orderServicesIds.includes(service.id)) {
            const tmp = [...orderServices];
            const tmpService = {
                ...service,
                addedProducts: service.completeProducts.map(product => {
                    return {
                        id: product.id,
                        name: product.name, 
                        description: product.description, 
                        sku: product.sku,
                        price: 0,
                        quantity: 1,
                        carMake: product.carMake,
                        carType: product.carType,
                        carYear: product.carYear,
                        carPart: product.carPart,
                        stocks: product.stocks,
                        addedStocks: product.stocks.map((ps) => {return {
                            id: ps.id,
                            supplier: ps.supplier,
                            available: ps.quantity,
                            unitPrice: ps.unitPrice,
                            sellingPrice: ps.sellingPrice,
                            quantity: 0,
                            price: ps.sellingPrice, 
                        }})
                    }
                })
            }
            tmp.push(tmpService);
            setOrderServices(tmp);
            // console.log(tmp);
        } else if (!checked && orderServicesIds.includes(service.id)) {
            const tmp = orderServices.filter(os => os.id !== service.id);
            setOrderServices(tmp);
            // console.log(tmp);
        }
    }

    const onToggleShownItems = (serviceId) => {
        if (shownItems.includes(serviceId)) {
            const tmp = shownItems.filter(si => si !== serviceId);
            setShownItems(tmp);
        } else {
            const tmp = [...shownItems];
            tmp.push(serviceId);
            setShownItems(tmp);
        }
    }


    // useEffect(() => {
    //     console.log(shownItems);
    // }, [shownItems]);


    return (
        
        <FormControl marginBottom="12px" overflow={"auto"}>
           
            <Flex direction="row" w="100%" justifyContent="space-between">
                <Text fontSize="sm" color="gray.400" fontWeight="bold" mb={1}>
                    SELECT SERVICES TO ADD
                </Text>
                <FormControl display="flex" alignItems="center">
                    <Switch 
                        defaultChecked={showArchived}
                        colorScheme="teal" 
                        me="10px" 
                        onChange={(e) => {
                            setShowArchived(e.target.checked);
                            setGettingServices(true);
                        }}
                    />
                    <FormLabel
                        mb="0"
                        ms="1"
                        fontWeight="normal"
                        >Toggle Archives
                    </FormLabel>
                </FormControl>
            </Flex>
            <Box p={0} w="100%">
                <Input
                    borderRadius="15px"
                    mb="12px"
                    fontSize="xs"
                    type="text"
                    placeholder="Search by title"
                    size="xs" 
                    defaultValue={keyword}
                    onChange={e => {
                        setKeyword(e.target.value);
                        setGettingServices(true);
                    }}
                />
            </Box>
            {   gettingServices
                ? <Progress isIndeterminate />
                : <Flex flexDirection="column" w="100%">
                    {   services.map((service, sIndex) => {
                            if (!service.title.toLowerCase().includes(keyword.toLowerCase())) {
                                return;
                            }
                            return <Flex 
                                flexDirection="column" 
                                w="100%"
                                key={`service-${service.id}`}
                                wrap={"wrap"}
                                >
                                <ButtonGroup mb={1} size="sm" isAttached variant="outline">
                                    { onOrderServices(service.id)
                                        ? <IconButton 
                                            aria-label="Remove to Order" 
                                            colorScheme="red"
                                            icon={<MinusIcon />} 
                                            onClick={() => onToggleService(service, false)}
                                            // disabled={disabledServices.includes(service.id)}
                                            // onClick={disabledServices.includes(service.id) 
                                            //     ? null
                                            //     : () => onToggleService(service, false)
                                            // }
                                        />
                                        : <IconButton 
                                            aria-label="Add to Order" 
                                            colorScheme="green"
                                            icon={<AddIcon />} 
                                            onClick={() => onToggleService(service, true)}
                                            // disabled={disabledServices.includes(service.id)}
                                            // onClick={ disabledServices.includes(service.id)
                                            //     ? null 
                                            //     : () => onToggleService(service, true)
                                            // }
                                        />
                                    }
                                    <Button 
                                        mr="-px"
                                        colorScheme={ services.includes(service.id) ? "black" : "grey"} 
                                        onClick={() => onToggleShownItems(service.id)}
                                        // onClick={() => {}}
                                        textColor={ services.includes(service.id) ? "black" : "grey" }
                                    >{service.title} (₱{service.discountedPrice > 0 
                                        ? Number(service.discountedPrice).toLocaleString() 
                                        : Number(service.price).toLocaleString()})
                                    </Button>
                                </ButtonGroup>
                                { shownItems.includes(service.id)
                                    ? <FormControl m={2} ml={8}>
                                        <Text fontSize="xs" color="gray.400" fontWeight="bold">
                                            ITEMS PRE-INCLUDED
                                        </Text>
                                        { service.completeProducts.length > 0 
                                            ?  <Flex flexDirection="column" w="100%">
                                                { service.completeProducts.map((op, opIndex) => {
                                                    return <Box key={`addedproducts-${opIndex}`}>
                                                        <Flex flexDirection="row" 
                                                            w="100%" 
                                                            align={"center"} 
                                                            mt={"4px"}
                                                            >
                                                            <Text 
                                                                fontSize="xs" 
                                                                // color="gray.400" 
                                                                key={`added-prods-label-${service.id}-${op.id}`}
                                                                >
                                                                {op.name} 
                                                                { op.carMake || op.carType || op.carYear || op.carPart
                                                                    ? `${op.carMake ? op.carMake : ""}
                                                                    ${op.carType ? op.carType : ""}
                                                                    ${op.carYear ? op.carYear : ""}
                                                                    ${op.carPart ? " Part No: " +op.carPart : ""}`
                                                                    : ""
                                                                }
                                                            </Text>
                                                        </Flex>
                                                    </Box>
                                                })}
                                            </Flex>
                                            : <Text 
                                                fontSize="xs" 
                                                >
                                                None
                                            </Text>
                                        }
                                    </FormControl>
                                    : null 
                                }
                                
                            </Flex>
                        })
                    }
                </Flex>
            }
        </FormControl>
    );
}


export default EstimateService;